import React from 'react'

import { LntDatePicker } from '@app/components/base'

import type { Dayjs } from 'dayjs'
import type { ReactElement } from 'react'
import type { DatePickerRendererProps } from './types'

export const DatePickerRenderer =
  <RecordType = unknown>
  (props: DatePickerRendererProps<RecordType>): ReactElement => {
    const { record, onChange, ...restProps } = props

    const handleChange = (value: Dayjs | null, dateString: string): void => {
      onChange?.(value, dateString, record)
    }

    return (
      <LntDatePicker
        { ...restProps }
        onChange={ handleChange }
      />
    )
  }
